import { fadeIn, slideInLeft } from '@/constants/motions';
import Image from '@/ui/Image';
import { motion } from 'framer-motion';

export default function BrandHeroBlock({ image, title }) {
  return (
    <motion.section
      className="relative"
      initial="hidden"
      transition={fadeIn.transition}
      variants={fadeIn}
      viewport={fadeIn.viewport}
      whileInView="visible"
    >
      <Image
        alt="Hero image"
        className="h-72 w-full object-cover sm:h-80 lg:h-[600px]"
        src={image}
      />
      <div className="absolute inset-0 h-full w-full bg-gradient-to-b from-black/20 to-primary-600/50">
        <motion.div
          className="flex h-full flex-col items-start justify-end gap-2 pr-4 lg:gap-4"
          initial="hidden"
          transition={{
            ...slideInLeft.transition,
            delay: 0.4,
            when: 'beforeChildren',
            staggerChildren: 0.4,
          }}
          variants={slideInLeft}
          viewport={slideInLeft.viewport}
          whileInView="visible"
        >
          <motion.div
            className="h-4 w-4/6 rounded-r-full bg-primary-500 sm:h-6 lg:h-8"
            variants={slideInLeft}
          ></motion.div>
          <motion.div
            className="rounded-r-full bg-primary-500 py-4 pl-4 pr-8 text-white sm:py-6 lg:py-8 xl:w-3/6 xl:pl-0"
            variants={slideInLeft}
          >
            <h1 className="xl:ml-container-offset text-3xl font-medium lg:text-5xl">{title}</h1>
          </motion.div>
          <motion.div
            className="h-6 w-11/12 rounded-r-full bg-primary-500 sm:h-8 lg:h-16"
            variants={slideInLeft}
          ></motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
}
